import { useLoaderData } from '@tanstack/react-router';
import { ASSET_ROUTE_URL } from '../../constants/routes';
import { useModalState } from '../../hooks/useModalState';
import { useProducts } from '../../hooks/useProducts';
import { useTailwindBreakpoint } from '../../hooks/useTailwindBreakpoint';
import { CancelAllOrdersModal } from '../CancelAllOrdersModal/CancelAllOrdersModal';
import { CloseAllPositionsModal } from '../CloseAllPositionsModal/CloseAllPositionsModal';
import { ClosePositionModal } from '../ClosePositionModal/ClosePositionModal';
import { ConfirmOrderModal } from '../ConfirmOrderModal/ConfirmOrderModal';
import { LeverageModal } from '../LeverageModal';
import { TimeInForceModal } from '../TimeInForceModal/TimeInForceModal';
import { WithdrawModal } from '../WithdrawModal/WithdrawModal';
import { useSyncUrlToTradeFormState } from './hooks/useSyncUrlToTradeFormState';
import { TradePageDesktop } from './TradePageDesktop';
import { TradePageDocumentTitle } from './TradePageDocumentTitle';
import { TradePageMobile } from './TradePageMobile/TradePageMobile';

export const TradePage = () => {
  const setWithdrawalModal = useModalState((state) => state.setWithdrawalModal);
  const { product: loaderProduct } = useLoaderData({ from: ASSET_ROUTE_URL });
  const { data: products } = useProducts();
  const isLg = useTailwindBreakpoint('lg');
  useSyncUrlToTradeFormState();

  // Use latest product data if available, otherwise fall back to loader data
  const product = products?.find(({ id }) => id === loaderProduct.id) ?? loaderProduct;

  return (
    <>
      <TradePageDocumentTitle product={product} />
      {isLg ? <TradePageDesktop product={product} /> : <TradePageMobile product={product} />}
      <WithdrawModal
        onWithdraw={async () => {
          setWithdrawalModal('closed');
        }}
      />
      <LeverageModal product={product} />
      <ClosePositionModal />
      <ConfirmOrderModal product={product} />
      <CloseAllPositionsModal />
      <CancelAllOrdersModal />
      <TimeInForceModal />
    </>
  );
};
